module.exports = __webpack_public_path__ + "img/shenzhen18.e18a85a9.png";